
/**
 * This file has been generated from JSON file C:\Users\scale\dev\iotize\bitbucket\standalone\iotize-device-client.js\assets\schema\v1\tap-types.json
 */ 
export default {
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "http://iotize.com/schemas/v1/tap-types.json",
  "definitions": {
    "NfcPairingMode": {
      "title": "NfcPairingMode config",
      "type": "string",
      "enum": ["NO", "MANDATORY", "MANDATORY_FOR_LOGIN"],
      "default": "NO"
    },
    "ModbusVariableAddress": {
      "title": "ModbusVariableAddress",
      "type": "object",
      "required": ["functionCode", "slave", "address"],
      "additionalProperties": false,
      "properties": {
        "functionCode": {
          "type": "integer",
          "minimum": 0,
          "maximum": 256
        },
        "slave": {
          "type": "integer",
          "minimum": 0,
          "maximum": 256
        },
        "address": {
          "type": "integer",
          "minimum": 0,
          "maximum": 65536
        }
      }
    },
    "WifiKeyVisibility": {
      "title": "WifiKeyVisibility",
      "type": "integer",
      "enum": ["VISIBLE", "HIDDEN"]
    },
    "WifiSSIDVisibility": {
      "title": "WifiSSIDVisibility",
      "type": "integer",
      "enum": ["VISIBLE", "HIDDEN_FROM_SCAN", "HIDDEN"]
    },
    "WifiProtocol": {
      "title": "WifiProtocol",
      "type": "integer",
      "enum": ["B", "G", "N"]
    },
    "TargetProtocol": {
      "title": "Target protocol config",
      "type": "string",
      "default": "NONE",
      "examples": ["SWD"],
      "enum": [
        "NONE",
        "SWD",
        "S3P",
        "JTAG",
        "MODBUS",
        "GPIO",
        "SERIAL",
        "CUSTOM"
      ]
    },
    "VariableFormat": {
      "title": "VariableFormat config",
      "type": "string",
      "default": "_32_BITS",
      "examples": ["_32_BITS"],
      "enum": ["_1_BIT", "_8_BITS", "_16_BITS", "_32_BITS"]
    },
    "VariableType.Data": {
      "description": "Variable type config",
      "title": "VariableTypeConfig",
      "type": "string",
      "default": "UINT32",
      "examples": ["UINT32"],
      "enum": [
        "INT8",
        "INT16",
        "INT32",
        "UINT8",
        "UINT16",
        "UINT32",
        "FLOAT32",
        "STRING"
      ]
    },
    "SpecialFeature": {
      "title": "SpecialFeature config",
      "type": "string",
      "examples": ["SWD_DIRECT_ACCESS"],
      "enum": [
        "SWD_DIRECT_ACCESS",
        "SERIAL_ACCESS",
        "MODBUS_DIRECT_ACCESS",
        "TAPNPASS_CONTROL_ACCESS",
        "SP_CODEEXEC_ACCESS"
      ]
    },
    "HostProtocol": {
      "title": "HostProtocol config",
      "type": "string",
      "examples": ["BLE"],
      "enum": ["NFC", "BLE", "WIFI", "LORA"],
      "tsEnumNames": ["NFC", "BLE", "WIFI", "LORA"]
    },
    "LowPowerOptimizationLevel": {
      "title": "LowPowerOptimizationLevel config",
      "type": "string",
      "default": "NO",
      "examples": ["NO"],
      "enum": ["NO", "STANDBY", "SHUTDOWN"]
    },
    "WifiMode": {
      "title": "Network mode config",
      "type": "string",
      "default": "PEER_TO_PEER",
      "examples": ["PEER_TO_PEER"],
      "enum": ["PEER_TO_PEER", "NETWORK"]
    },
    "UartSettings": {
      "title": "UartSettings config",
      "type": "object",
      "additionalAttributes": false,
      "attributes": {
        "slv": {
          "type": "integer",
          "minValue": 0,
          "maxValue": 255
        },
        "ofs": {
          "type": "boolean"
        },
        "baudRate": {
          "type": "integer",
          "minValue": 0
        },
        "physicalPort": {
          "$ref": "#/PhysicalPort"
        },
        "stopBit": {
          "$ref": "#/StopBit"
        },
        "bitParity": {
          "$ref": "#/BitParity"
        },
        "dataBits": {
          "$ref": "#/DataBitsLength"
        },
        "handshakeDelimiter": {
          "$ref": "#/HandshakeDelimiter"
        },
        "handshakeValue": {
          "$ref": "#/Handshake"
        },
        "timeout": {
          "type": "integer",
          "minValue": 0,
          "maxValue": 255
        }
      }
    },
    "BitParity": {
      "title": "BitParity",
      "type": "string",
      "enum": ["NONE", "ODD", "EVEN"]
    },
    "Handshake": {
      "title": "Handshake",
      "type": "string",
      "enum": ["NONE", "RTS", "CTS", "RTS_CTS"]
    },
    "StopBit": {
      "title": "StopBit",
      "type": "string",
      "enum": ["ONE", "ONE_AND_HALF", "TWO"]
    },
    "PhysicalPort": {
      "title": "PhysicalPort",
      "type": "string",
      "enum": ["NONE", "RS232", "USB", "AUTO", "RS485"]
    },
    "HandshakeDelimiter": {
      "title": "HandshakeDelimiter",
      "type": "string",
      "enum": ["NONE", "CR", "LF", "CR_LF"]
    },
    "DataBitsLength": {
      "title": "DataBitsLength",
      "type": "string",
      "enum": ["_7", "_8", "_9"]
    },
    "SecurityConfig": {
      "title": "SecurityConfig",
      "additionalProperties": false,
      "type": "object",
      "required": [
        "scramActivated",
        "hashPassword",
        "factoryReset",
        "disableLoginWithUID",
        "disableResourceFactoryReset"
      ],
      "properties": {
        "scramActivated": {
          "type": "boolean",
          "title": "Enable SCAN authentification",
          "default": false
        },
        "hashPassword": {
          "type": "boolean",
          "default": true
        },
        "disableHardwareFactoryReset": {
          "title": "Locking factory reset with lwm2m",
          "type": "boolean",
          "default": false
        },
        "disableLoginWithUID": {
          "title": "Disable login with UID",
          "type": "boolean",
          "default": false
        },
        "disableResourceFactoryReset": {
          "title": "Disable hardware factory reset",
          "type": "boolean",
          "default": false
        }
      }
    },
    "SpecialUsername": {
      "title": "SpecialUsername config",
      "enum": ["admin", "supervisor"]
    },
    "UsbAlias": {
      "title": "UsbAlias  config",
      "type": "object",
      "additionalProperties": false,
      "required": ["vid", "pid", "equ"],
      "properties": {
        "vid": {
          "allOf": [
            {
              "$ref": "common.json#/definitions/hexString"
            },
            {
              "tsType": "any",
              "maxLength": 6
            }
          ]
        },
        "pid": {
          "allOf": [
            {
              "$ref": "common.json#/definitions/hexString"
            },
            {
              "tsType": "any",
              "maxLength": 6
            }
          ]
        },
        "equ": {
          "type": "integer",
          "maximum": 5,
          "minimum": 0
        }
      }
    }
  }
}
;
        